import commonMixIn from "./../common.mixin"
import { BasicText } from "./../basic/index"
import { getStorage, removeStorage, setStorage } from "../../utils/storage"
// 跳过20分钟过期
export const SkipExpired = 30 * 60 * 1000
// export const SkipExpired = 3  * 1000

export const AcceptPrivacy = function(PrivacyKey) {
    let _current = getStorage(PrivacyKey)
    return _current && _current.status === "accept"
}
export const SkipPrivacyValid = function(PrivacyKey) {
    let _current = getStorage(PrivacyKey)
    return _current && (_current.at > (Date.now() - SkipExpired))
}
export default {
    mixins: [commonMixIn],
    components: {
        BasicText
    },
    data() {
        return {
            show: true,
            defaultLs: {
                status: "waiting"
            }
        }
    },
    created() {
        this.PrivacyKey = `Privacy_${this._siteId}`

        this.show = !(AcceptPrivacy(this.PrivacyKey) || SkipPrivacyValid(this.PrivacyKey))
    },
    methods: {
        onConfirm() {
            this.updateLocal("accept")
            this.delUserInfo()
            this.$emit("privacy-confirm")
            this.show = false
        },
        onCancel() {
            this.updateLocal("reject")
            this.delUserInfo()
            this.show = false
            this.$emit("privacy-cancel")
        },
        onClose() {
            this.updateLocal("skip")
            this.show = false
            this.$emit("privacy-cancel")
        },
        delUserInfo() {

            removeStorage("_ca")
        },
        updateLocal(status) {
            let _current = getStorage(this.PrivacyKey)

            setStorage(this.PrivacyKey, Object.assign({}, _current, {
                status: status,
                at: Date.now()
            }))
        }
    },
    computed: {
        getWrapperStyle() {
            if (this.data) {
                return Object.assign({}, this.data.style.listStyle, this.data.style.listStyle.background, {
                    ...this.getPadding(this.data.style.listStyle.padding),
                    ...this.getMargin(this.data.style.listStyle.margin)
                })
            }
        }
    }
}
